import {
  FluidFormElementState,
  FluidProgressState,
  FluidTheme,
  FluidToggleConfig,
} from '@lmig/fluid-core';
import { FunctionalComponent, h } from '@stencil/core';

import { FluidFunctionalComponentProps } from '../../../model/functional/fluid-functional-component-props.interface';
export type ToggleAllValue = boolean | FluidProgressState.INDETERMINATE;

interface ToggleGroupProps extends FluidFunctionalComponentProps {
  config: FluidToggleConfig;
  setRef: (el: HTMLFluidToggleElement) => void;
  toggled?: ToggleAllValue;
  handleToggleChange?: (value: FluidFormElementState) => void;
  disabled?: boolean;
  theme: FluidTheme;
}

interface ToggleAllProps extends ToggleGroupProps {
  handleToggleAllChange: (value: FluidFormElementState) => void;
}

// ================================================================ //
// -- Public Functional Components

/**
 * "Toggle All" Toggle
 */
export const ToggleAll: FunctionalComponent<ToggleAllProps> = (
  props: ToggleAllProps
) => {
  const { config, setRef, handleToggleAllChange, theme } = props;

  if (!config) return;
  return (
    <fluid-toggle
      class='toggle-all'
      config={{ ...config, _standalone: false }}
      theme={theme}
      overrideGlobalTheme={true}
      ref={(el: HTMLFluidToggleElement) => !!el && setRef(el)}
      onValueChange={(value: CustomEvent<FluidFormElementState>) =>
        handleToggleAllChange(value.detail)
      }
    />
  );
};

/**
 * Individual Toggle
 */
export const ToggleGroupToggle: FunctionalComponent<ToggleGroupProps> = (
  props: ToggleGroupProps
) => {
  const { config, setRef, toggled, handleToggleChange, theme, disabled } =
    props;

  return (
    <fluid-toggle
      key={config.id}
      config={{ ...config, disabled, _standalone: false }}
      toggled={toggled}
      theme={theme}
      overrideGlobalTheme={true}
      ref={(el: HTMLFluidToggleElement) => !!el && setRef(el)}
      onValueChange={(value: CustomEvent<FluidFormElementState>) =>
        handleToggleChange(value.detail)
      }
    />
  );
};
